import React from "react";

type Props = {
  isBlocked: boolean;
  mock: React.ReactNode;
  real: React.ReactNode;
};

export const BlockedView = ({
  isBlocked,
  mock,
  real,
}: Props): React.ReactNode => {
  if (isBlocked) {
    return mock;
  }
  return real;
};
